var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9E9E0;}\r\n\t.st1{fill:#C11032;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C63247;}\r\n\t.st4{fill:#D9D7CA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1_00000122698601164007587760000015924200122756551341_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.4,59.8H113.8c-5.5,0-9.9,4.4-9.9,13v359.6c0,2.3,4.4,6.8,9.9,6.8h271.5c5.5,0,9.9-4.4,9.9-6.8V147.7 c0-4.7-0.6-6.2-1.7-7.3l-78.8-78.8C313.5,60.4,312,59.8,310.4,59.8L310.4,59.8z M310.4,59.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M385.2,439.2H113.8c-5.5,0-9.9-4.4-9.9-9.9V324h291.3v105.3C395.1,434.7,390.7,439.2,385.2,439.2L385.2,439.2z  M385.2,439.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.6,350.6h11.3v68.2h-11.3v-46.9l-15.3,38h-9.8l-15.4-38v46.9h-11.3v-68.2h11.3l20.3,46.7L211.6,350.6z  M211.6,350.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.9,418.8h-11.1v-68.2h19.6c2.9,0,5.8,0.5,8.6,1.4c2.8,0.9,5.4,2.3,7.6,4.2c2.3,1.9,4.1,4.1,5.5,6.7 c1.4,2.6,2.1,5.6,2.1,8.8c0,3.5-0.6,6.6-1.8,9.4c-1.2,2.8-2.8,5.2-4.9,7.1c-2.1,1.9-4.6,3.4-7.6,4.4c-2.9,1.1-6.2,1.6-9.8,1.6h-8.2 V418.8z M250.9,359v27h10.2c1.4,0,2.7-0.2,4-0.7c1.3-0.5,2.5-1.2,3.7-2.3c1.1-1,2-2.5,2.7-4.4c0.7-1.9,1-4.2,1-7 c0-1.1-0.2-2.4-0.5-3.8c-0.3-1.5-1-2.8-1.9-4.2c-1-1.3-2.3-2.4-4-3.3c-1.8-0.9-4-1.3-6.9-1.3H250.9z M250.9,359"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.5,402.9H291v-8.8l29.5-43.5h11.3v43.5h7.1v8.8h-7.1v15.9h-11.3V402.9z M320.5,394.1v-30.6l-19.6,30.6 H320.5z M320.5,394.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.8,249.5c-1.1,0-2.2-0.3-3.2-0.8c-2.2-1.2-3.5-3.5-3.5-5.9v-94.9c0-2.4,1.3-4.7,3.5-5.9 c2.2-1.2,4.8-1.1,6.9,0.2l74.5,47.4c1.9,1.3,3.1,3.4,3.1,5.7c0,2.3-1.2,4.5-3.1,5.7l-74.5,47.4 C228.3,249.1,227.1,249.5,225.8,249.5L225.8,249.5z M232.6,160.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.9,296.9c-56,0-101.6-45.6-101.6-101.6c0-56,45.6-101.6,101.6-101.6c56,0,101.6,45.6,101.6,101.6 C354.5,251.3,308.9,296.9,252.9,296.9L252.9,296.9z M252.9,107.3c-48.6,0-88.1,39.5-88.1,88c0,48.6,39.5,88,88.1,88 c48.6,0,88-39.5,88-88C341,146.7,301.5,107.3,252.9,107.3L252.9,107.3z M252.9,107.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M313.9,60.8v80.3h80.2L313.9,60.8z M313.9,60.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.3b0faa1b34e2cc41e14bc7ab97b6acb5.svg";
export { ForwardRef as ReactComponent };